import { Card, CardContent, Typography, Box, Avatar } from "@mui/material";
import { format } from "date-fns";
import IconifyIcon from "../../base/IconifyIcon";

const WeatherWidget = ({ weather = {} }) => {
  const {
    location = "Farm HQ",
    temperature = 26,
    condition = "Partly Cloudy",
    humidity = 55,
    wind = 12,
    updatedAt = new Date(),
    icon = "wi:cloudy",
  } = weather;

  const thermometerIcon = "wi:thermometer";
  const humidityIcon = "wi:humidity";
  const windIcon = "wi:strong-wind";

  return (
    <Card elevation={3} sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Weather Update
        </Typography>

        <Box display="flex" alignItems="center" gap={2}>
          <Avatar
            sx={{
              bgcolor: "primary.light",
              width: 56,
              height: 56,
              fontSize: 30,
            }}
          >
            <IconifyIcon icon={icon} width={30} height={30} />
          </Avatar>

          <Box>
            <Typography variant="h4">{temperature}°C</Typography>
            <Typography color="text.secondary">{condition}</Typography>
            <Typography color="text.secondary">{location}</Typography>
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" mt={3}>
          <Box display="flex" alignItems="center" gap={1}>
            <IconifyIcon icon={thermometerIcon} width={20} height={20} />
            <Typography variant="body2">{temperature}°C</Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <IconifyIcon icon={humidityIcon} width={20} height={20} />
            <Typography variant="body2">{humidity}%</Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <IconifyIcon icon={windIcon} width={20} height={20} />
            <Typography variant="body2">{wind} km/h</Typography>
          </Box>
        </Box>

        <Typography
          variant="caption"
          color="text.secondary"
          mt={2}
          display="block"
        >
          Updated at {format(new Date(updatedAt), "HH:mm, MMM d")}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default WeatherWidget;
